import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { TimePeriod } from '../../utils/config/user-enums'
import './Filter.css'

interface FilterModalProps {
  open: boolean
  handleClose: () => void
  activeFilter: string
  handleFilterChange: (filter: TimePeriod) => void
  filterModelStyle?: string
}

const FilterModal: React.FC<FilterModalProps> = ({
  open,
  handleClose,
  activeFilter,
  handleFilterChange,
  filterModelStyle,
}) => {
  const filters = [
    TimePeriod.DAILY,
    TimePeriod.WEEKLY,
    TimePeriod.MONTHLY,
    TimePeriod.YEARLY,
    TimePeriod.ALL,
  ]

  const handleClick = (filter: TimePeriod) => {
    handleFilterChange(filter)
    handleClose()
  }

  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box className={`filter-modal ${filterModelStyle}`}>
        <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
          Filter
        </Typography>
        <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
          <div className="filter-tab">
            {filters.map((filter) => (
              <div
                key={filter}
                className={`filter-item ${
                  activeFilter === filter
                    ? 'active-filter-item-bg'
                    : 'normal-filter-item-bg'
                } cursor-pointer`}
                onClick={() => handleClick(filter)}
              >
                {filter?.charAt(0)?.toUpperCase() + filter.slice(1)}
              </div>
            ))}
          </div>
        </Typography>
      </Box>
    </Modal>
  )
}

export default FilterModal
